/* eslint-disable max-len */
/* eslint-disable security/detect-object-injection */

import React, { useContext, useEffect, useState, useCallback } from 'react';
import { Link, useNavigate, useSearchParams } from 'react-router-dom';
import { HandleInputChange } from '../../../../../components/InputFeld/inputChange';
import SundryCreditors from './SundryCreditors';
import BankOD from './BankOD';
import { CognitoData } from '../../../../../CommonMethods/CognitoData';
import { dataService } from '../../../../../services/data.services';
import GlobalContext from '../../../../../components/Context/GloablContext';
import CardHeader from '../../../../../components/CardHeader';
import AddGroups from './AddGroups';
import Toast from '../../../../../components/Toast';
import Loader from '../../../../../components/Loader';
import { GetBranchId } from '../../../../../CommonMethods/GetBranchId';
import Debounce from '../../../../../CommonMethods/Debounce';

const AddEditGroupsLegers = ({Type}) => {
    const {setToastmessage}=useContext(GlobalContext);
    const [toastErrorMessage, setToastErrorMessage] = useState('')
    const [GSTError, setGSTError] = useState(false)
    const [searchParams, setSearchParams] = useSearchParams()
    const initalRecode = {
        group_name: "",
        ledger_name: "",
        description: "",
        type: "",
        group_type: "PL",
        parent_group: {
            parent_group_id: "",
            parent_group_name: "",
        },
        branch_id: "",
        opening_balance: null,
        opening_balance_type: "",
        gst_number: "",
        pan_number: "",
        billing_address: "",
        bank_name: "",
        account_holder_name: "",
        ifsc_code: "",
        account_number: null,
        swift_transfer_code: "",
        account_name: "",
        account_type: "",
        branch_name: "",
        associated_position: "",
    } 
    const navigate= useNavigate();
    const bankODExist = [
        "description",
        "swift_transfer_code",
        "group_name",
        "type",
        "group_type",
        "branch_id",
        "gst_number",
        "pan_number",
        "billing_address",
        "associated_position",
        "opening_balance",
        "account_name"
    ]
    const sundryCreditorExist = [
        "description",
        "group_name",
        "type",
        "group_type",
        "branch_id",
        "associated_position",
        "gst_number",
        "branch_name",
        "account_name",
        "account_type",
        "opening_balance",
        "swift_transfer_code",
    ]
    const existKeyGroup = [
        "ledger_name",
        "description",
        "type",
        "group_type",
        "branch_id",
        "opening_balance",
        "is_debit",
        "gst_number",
        "pan_number",
        "billing_address",
        "bank_name",
        "account_holder_name",
        "ifsc_code",
        "account_number",
        "swift_transfer_code",
        "account_name",
        "account_type",
        "branch_name",
        "opening_balance_type",
        "opening_balance",
        "associated_position"]
    const existKey = [
        "group_name",
        "description",
        "type",
        "group_type",
        "branch_id",
        "opening_balance",
        "is_debit",
        "gst_number",
        "pan_number",
        "billing_address",
        "bank_name",
        "account_holder_name",
        "ifsc_code",
        "account_number",
        "swift_transfer_code",
        "account_name",
        "account_type",
        "branch_name",
        "opening_balance",
        "associated_position"]
    const [recodes, setRecodes] = useState(initalRecode);
    const [loadingSearch, setLoadingSearch] = useState(true);
    const [selectedGroupType, setSelectedGroupType] = useState("");
    const [isSchemeGroup, setIsSchemeGroup] = useState(false);
    const [loadingSpinner, setLoadingSpinner] = useState(false);
    const [searchValue, setSearchValue] = useState("");
    const [exitVal, setExitVal] = useState(false);
    const [descriptionLength, setDescriptionLength] = useState(false)
    const queryParams = new URLSearchParams(window.location.search);
    const tab = queryParams.get('tab');
    const [isAlreadyExit, setIsAlreadyExit] = useState(false)
    const [groupList, setGroupList] = useState([]);
    const panCardRegex=/[A-Z]{5}[0-9]{4}[A-Z]{1}/
    const tabTypes = ["Ledgers", "Groups"]

    /**
     * The function `handelCheckboxType` is used to handle different types of checkboxes and update the
     * state accordingly.
     */
    const handelCheckboxType = (val, key, position) => {
        setSearchValue("");
        setDescriptionLength(false)
        setExitVal(false);
        setGSTError(false)
        setToastErrorMessage("")
        if(key === "type") {
            setRecodes(initalRecode)
            setSelectedGroupType("")
            setIsSchemeGroup(false)
            setExitVal(false)
            setGSTError(false)
        } else if(key === "parent_group") {
            setRecodes((prv)=>({
                ...prv,
                ["associated_position"]: position
            }))
            setExitVal(false)
            setGSTError(false)
        } else if (key === "group_type") {
            
            setSelectedGroupType("")
            setIsSchemeGroup(false)
            setRecodes((prv)=>({
                ...prv,
                ["associated_position"]: "",
                ["parent_group"]: {
                    parent_group_id: "",
                    parent_group_name: "",
                },
            }))
        }
        setRecodes((prv)=>({
            ...prv,
            [key]:val
        }))
        if (key === "group_type") {
            getListOfGroups("",val);
        }
        getBranchId()
    }

    /**
     * The function `getBranchId` retrieves the branch ID from local storage and sets it in the state
     * based on the user type.
     */
    const getBranchId = async() => {
        const localData = JSON.parse(localStorage.getItem('branch_details'));
        const user = await CognitoData();
        setRecodes((prv)=>({
            ...prv,
            ["branch_id"]:user.idToken.payload["custom:user_type"] === "institution-user" ? localData.id : user.idToken.payload["custom:branch_id"]
        }))
    }

    /* The above code is a useEffect hook in a React component. It is used to perform side effects in a
    functional component. */
    useEffect(() => {
        if(tab === null || tab !== 'groups' || tab !== 'ledger') {
            navigate(`/main-hub/groups-ledgers/add-groups-ledgers?tab=${(tab === null || tab !== 'groups' || tab !== 'ledger') ? "ledgers" : tab}`)
            handelCheckboxType("ledger", "type");    
        } else {
            // navigate(`/main-hub/groups-ledgers/add-groups-ledgers?tab=${tab}`)
            handelCheckboxType(tab === 'groups' ? "group" : "ledger", "type");      
        }
        getBranchId()
    }, [])

    /**
     * The function `handleOnchangeInput` is used to handle the change event of an input field in a
     * React component.
     */
    const handleOnchangeInput = (e) => {
        setGSTError(false)
        setExitVal(false);
        setToastErrorMessage("")
        setIsAlreadyExit(false);
        if(e.target.id === "description" && e.target.value?.length === 100) {
            setToastErrorMessage('Description cannot exceed 100 words')
            setDescriptionLength(true)
        }
        HandleInputChange(e, setRecodes)
    }

    /**
     * The function `getListOfGroup` is an asynchronous function that retrieves a list of groups based
     * on a search value, sets loading state, retrieves user data, sets search value, retrieves local
     * data, makes an API call to get the group list, and sets the group list and loading state.
     */
    const getListOfGroups = async(searchVal,group_type) => {
        setLoadingSearch(true);
        try {
            const user = await CognitoData();
            const localData = JSON.parse(localStorage.getItem('branch_details'));
            let res = await dataService.GetAPI(`groups-and-ledgers?filter=true${recodes.type === "group" ? `&group_type=${group_type || recodes.group_type}&type=group&include_main_group=true` : '&status=active&type=group&include_main_group=true'}&branch_id=${(user.idToken.payload["custom:user_type"] === "institution-user" || user.idToken.payload["custom:user_type"] === "institution-admin") ? localData.id : user.idToken.payload["custom:branch_id"]}${(searchVal !== undefined && searchVal !== "")? `&search=${encodeURIComponent(searchVal)}` : ""}`);
            setGroupList(res?.data?.data?.data);
            setLoadingSearch(false);
        } catch (error) {
            console.error("Error:", error);
            setToastErrorMessage(error?.response?.data?.message || "Something went wrong")
            setLoadingSearch(false);
        }
    };

    useEffect(()=>{
        getListOfGroups(searchParams?.get('search')|| '')
    },[searchParams])

    const setSearchValueParams = (searchVal) => {
        let newSearchParams = Object.fromEntries(searchParams);
        if(searchVal !== undefined && searchVal !== '') {
            setSearchValue(searchVal);
            newSearchParams.search = searchVal;
            setSearchParams(newSearchParams)
        } else {
            setSearchValue("");
            delete newSearchParams.search
            setSearchParams(newSearchParams)
        }
    }

    const debouncedGetListOfGroup = useCallback(
        Debounce((value) => setSearchValueParams(value)),
        [searchParams]
    );

    /**
     * The function `handleValidation` checks for errors in a given set of records and returns true if
     * there are no errors.
     * @returns The function `handleValidation` returns a boolean value. It returns `true` if there are
     * no errors in the validation process, and `false` if there are any errors.
     */
    const handleValidation=()=>{
        const ErrorArray=[];
        const filterArray = recodes.type === "group" ? existKeyGroup :( (selectedGroupType === "Sundry Creditors" || selectedGroupType === "Sundry Debtors") && !isSchemeGroup)
            ? sundryCreditorExist : (selectedGroupType === "Bank OD Account" || selectedGroupType === "Bank Accounts") ? bankODExist : existKey
        Object.keys(recodes).filter((val)=>!filterArray.includes(val)).map((key)=>{
            if(key === "parent_group") {
                if(recodes.parent_group.parent_group_id === "") {
                    ErrorArray.push(key)
                    setExitVal(true)
                }
            } else if (key === "opening_balance_type" ) {
                if(recodes.opening_balance !== null) {
                    if(recodes.opening_balance !== "") {
                        if(recodes.opening_balance_type === "" && recodes.group_type === 'BS') {
                            ErrorArray.push("opening_balance_type")
                            setExitVal(true)
                        }
                    }
                }
            } else if(recodes[key]==='' || recodes[key] === null){
                ErrorArray.push(key)
                setExitVal(true);
            }
        })
        return ErrorArray?.length===0
    }

    /**
     * The function `handlePanCheck` checks if the `pan_number` in the `recodes` object matches a PAN
     * card regex pattern.
     * @returns The function `handlePanCheck` is returning the result of the
     * `panCardRegex.test(recodes.pan_number)` expression.
     */
    const handlePanCheck=()=>{
        return panCardRegex.test(recodes.pan_number)
    }

    /**
     * The function `handelAddGroupsLeaguers` is an asynchronous function that handles the process of
     * adding groups and ledgers in a React application.
     */
    const handelAddGroupsLeaguers = async() => {
        setLoadingSpinner(true);
        setDescriptionLength(false)
        setIsAlreadyExit(false)
        setExitVal(false);
        setGSTError(false)
        setToastErrorMessage("")
        if(!handleValidation()){
            setToastErrorMessage('Please fill in all the mandatory fields')
            setLoadingSpinner(false)
        }else if(recodes.type !== "group" && ((selectedGroupType === "Sundry Creditors" || selectedGroupType === "Sundry Debtors") && !isSchemeGroup) && !handlePanCheck()) {
            if(recodes.gst_number !== '' && recodes.gst_number !== 15){
                setGSTError(true)
            }
            setToastErrorMessage("Please enter valid details")
            setExitVal(true)
            setLoadingSpinner(false)
        }else if(recodes.gst_number !== '' && recodes.gst_number.length !== 15){
            setGSTError(true)
            setExitVal(true)
            setToastErrorMessage("Length of GSTIN should be 15 characters")
            setLoadingSpinner(false)
        } else {
            try {
                let body = recodes;
                const branch_id = await GetBranchId()
                body["group_name"] = recodes.group_name.trim();
                body["ledger_name"] = recodes.ledger_name.trim();
                body["branch_id"] = branch_id;
                body["opening_balance"] = parseFloat(recodes.opening_balance, 10)
                const res = await dataService.PostAPI(body,'groups-and-ledgers');
                setToastmessage(res?.data?.data?.message) 
                navigate("/main-hub/groups-ledgers")
            } catch (error) {
                setLoadingSpinner(false);
                if(error.response.data.message === "This ledger name already exists. Try another" || error.response.data.message === "This group name already exists. Try another") {
                    setIsAlreadyExit(true)
                }
                setToastErrorMessage(error?.response?.data?.message || "Something went wrong")
                if(error.response.data.message === 'Length of GSTIN should be 15'){
                    setGSTError(true)
                }
                
            }
        } 
    }

    return (
        <>
            <CardHeader noPadding>
                <div class="mainDataCntnrTop shadow-s13">
                    <h5 class="pageHeader adderror">Add Ledger/Group</h5>
                    <div class="flex items-center">
                        <Link to={"/main-hub/groups-ledgers"}>
                            <button type="button" class="cancl-btn">
                                Cancel 
                            </button>
                        </Link>
                        <button onClick={() => handelAddGroupsLeaguers()} disabled={loadingSpinner} type="button" class="actn-btn onboardInstitution">
                            {loadingSpinner ? <Loader /> : "Add"} 
                        </button>
                    </div>
                </div>
                <div class="pb-10 relative"> 
                    <div class="overflow-y-auto overflow-x-hidden pt-[20px]">
                        <ul class="flex list-none flex-row flex-wrap border-b border-[#B3BBC1] pl-9 mx-10" role="tablist" data-te-nav-ref="">
                            {tabTypes.map((itemType) => (
                                <li key={itemType}>
                                    <Link onClick={() => {handelCheckboxType(itemType === 'Groups' ? "group" : "ledger", "type"); setToastErrorMessage(""); setIsAlreadyExit(false)}}  to={`/main-hub/groups-ledgers/add-groups-ledgers?tab=${itemType.toLowerCase()}`} class={`data-[te-nav-active]:text-[#031624] mr-[126px] tab-element ${tab === itemType.toLowerCase() ? "selected" : ""}`} data-te-toggle="pill" data-te-target="#tabs-institutionDetails" role="tab" aria-controls="tabs-institutionDetails" aria-selected="true" data-te-tab-active="">
                                        {itemType}
                                    </Link>
                                </li>))}
                        </ul>
                        <div class="scroll-bar tabbedPgListDiv">
                            <div class=" transition-opacity duration-150 ease-linear data-[te-tab-active]:block opacity-100">
                                <AddGroups 
                                    recodes={recodes}
                                    exitVal={exitVal} 
                                    handleOnchangeInput={handleOnchangeInput}
                                    handelCheckboxType={handelCheckboxType}
                                    getListOfGroup={debouncedGetListOfGroup}
                                    setSearchValue={setSearchValue}
                                    loadingSearch={loadingSearch}
                                    groupList={groupList}
                                    setSelectedGroupType={setSelectedGroupType}
                                    setIsSchemeGroup={setIsSchemeGroup}
                                    searchValue={searchValue}
                                    selectedGroupType={selectedGroupType}
                                    Type={Type}
                                    isAlreadyExit={isAlreadyExit}
                                    descriptionLength={descriptionLength}
                                />
                                <div class="pt-[40px] px-3 bg-white" >
                                    {recodes.type !== "group" && !isSchemeGroup && (selectedGroupType === "Sundry Creditors" || selectedGroupType === "Sundry Debtors") && <SundryCreditors 
                                        recodes={recodes}
                                        handleOnchangeInput={handleOnchangeInput}
                                        exitVal={exitVal}
                                        toastErrorMessage={toastErrorMessage}
                                        GSTError={GSTError}
                                        selectedGroupType={selectedGroupType}
                                    />}
                                    {recodes.type !== "group" && (selectedGroupType === "Bank OD Account" || selectedGroupType === "Bank Accounts") && <BankOD 
                                        groupList={groupList}
                                        selectedGroupType={selectedGroupType}
                                        getListOfGroup={debouncedGetListOfGroup}
                                        setSelectedGroupType={setSelectedGroupType}
                                        recodes={recodes}
                                        handelCheckboxType={handelCheckboxType}
                                        handleOnchangeInput={handleOnchangeInput}
                                        loadingSearch={loadingSearch}
                                        loadingSpinner={loadingSpinner}
                                        handelAddGroupsLeaguers={handelAddGroupsLeaguers}
                                        exitVal={exitVal}
                                        searchValue={searchValue}
                                    />}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                {toastErrorMessage!=='' &&<Toast
                    message={toastErrorMessage}
                    type="error"
                    setToastmessage={setToastErrorMessage} />}
            </CardHeader>
        </>
    );
}

export default AddEditGroupsLegers;
